import { useState, useEffect } from "react";
import { useSimpleKitContext } from "@/react/context/SimpleKitContext";
import { OptionButton } from "@/react/components/OptionButton";
import { INetwork } from "based-auth/networks";

export function NetworkButton({
  index,
  network,
  onClick,
}: {
  index: number;
  network: INetwork;
  onClick: () => void;
}) {
  const [logoIndex, setLogoIndex] = useState(-1);
  const { chains } = useSimpleKitContext();
  const selectedChains = chains.filter(
    (i) => i.network.symbol === network.symbol
  );

  useEffect((): any => {
    if (selectedChains.length > 1) {
      const interval = setInterval(() => {
        setLogoIndex((prev) => (prev + 1) % selectedChains.length);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, []);

  const currentLogo =
    logoIndex === -1 ? network.logo : selectedChains[logoIndex]?.logo;
  const logoKey = `${network.symbol}-${logoIndex}`;

  return (
    <OptionButton
      index={index}
      logo={currentLogo}
      logoKey={logoKey}
      onClick={onClick}
    >
      {network.name}
    </OptionButton>
  );
}
